import { Callout } from "src/design-system/Callout";
import { useChildHasAgentNode } from "src/flowContainer/RunFlowButton/useChildHasAgentNodes";
import { hasAgentNodeWithLiveData } from "src/flowContainer/RunFlowButton/utils";
import { useGraphStore } from "src/store/StoreProvider";

export const ExpectedAgentColumnsCallout = ({
  expectedColumns,
}: {
  expectedColumns: string[];
}) => {
  const { nodesArray } = useGraphStore();
  const hasChildAgentNode = useChildHasAgentNode();
  const hasAgentNode = hasAgentNodeWithLiveData(nodesArray);
  const includesAgents = hasChildAgentNode || hasAgentNode;

  if (includesAgents && expectedColumns.length > 0) {
    return (
      <Callout variant="warning" isEdgeToEdge>
        <p>
          Expected Output is not supported for Agent’s test runs at this moment
        </p>
      </Callout>
    );
  }

  return null;
};
